import Api from "../utils/axios";

export const NotificationApi = {
  getAllNotification: () => Api.post("/vendor/get-vendor-notification"),
  updateNotification: (id,payload) => Api.patch(`/order/update-order-notification/${id}`,payload),
//   getAllUsers: () => Api.get("/user/all"),
//   uploadFiles: (payload, options) => Api.post(`/upload`, payload, options),
};
